import * as React from 'react';

const TicketMultiSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="ticket-multi_svg__eds-icon--ticket-multi_svg"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill="#231f20"
            d="M20 3v19h-4v1h5V3h-1zM9.1 22a4.14 4.14 0 012.3-2.7 2.18 2.18 0 01.9.7 3.21 3.21 0 00-2.3 3H5v-1zM6 10.5h2v1H6zM10 10.5h2v1h-2zM14 10.5h2v1h-2z"
        />
        <path
            d="M14 1s0 3.5-3 3.5S8 1 8 1H3v20h5a2.94 2.94 0 012.88-3H11a2.94 2.94 0 013 2.88V21h5V1zm4 19h-3a3.72 3.72 0 00-4-3 3.72 3.72 0 00-4 3H4V2h3c.4 1.7 1.5 3.5 4 3.5s3.6-1.8 4-3.5h3z"
            fill="#231f20"
        />
    </svg>
);

TicketMultiSvg.displayName = 'TicketMultiSvg';
export default TicketMultiSvg;
